import { useState, useEffect } from "react";
import HeaderImage from "@assets/images/HeaderMotivationalCoach.svg";
import MainHeader from "@components/ui/MainHeader";
import DashboardSuggestion from "@features/MotivationalCoach/DashboardSuggestion";
import { gameMilestone, LockSleepCoach } from "@utils/defaultImages.js";
import GoalFeedBack from "@features/MotivationalCoach/GoalFeedBack.jsx";
import MilestonesPopup from "@components/common/Modals/MilestonesPopup.jsx";
import { achievements } from "data/uiData/Achievements.js";
import {
  createMotivationalPlan,
  fetchMotivationalData,
} from "@api/motivationalCoach";
import { BackImg } from "@utils/defaultImages";
import UploadIcon from "@assets/images/NoSubscriptionAstronot.png";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
import usePlanTimer from "@utils/DietPlanProgress";
import { useLoaderSlides } from "data/uiData/LoadersData";
import ReacreationLoading from "@components/ui/RecreationLoading";
import { useTranslation } from "react-i18next";
import AlertDialog from "@components/ui/ConfirmDialogue";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";

const MotivationCoach = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [badgeLocked, setBadgeLocked] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [data, setData] = useState(null);
  const [isPlanLoading, setIsPlanLoading] = useState(false);
  const [recreateLoading, setRecreateLoading] = useState(false);

  const [planInitiateTime, setPlanInitiateTime] = useState(null);
  const motivationSlides = useLoaderSlides("motivation");
  const { timeLeft, setTimeLeft, stopCountdown } = usePlanTimer(
    planInitiateTime,
    120
  );
  const fetchData = async () => {
    try {
      const response = await fetchMotivationalData();
      setData(response);
      setIsPlanLoading(response?.is_pending);
      setPlanInitiateTime(response?.start_time);
    } catch (error) {
      console.error(
        "Error fetching Data:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    fetchData();
    return () => {
      stopCountdown();
    };
  }, []);
  const handleRecreatePlan = async () => {
    setRecreateLoading(true);
    try {
      const response = await createMotivationalPlan();
      setIsPlanLoading(response?.is_pending);
      setPlanInitiateTime(response?.start_time);
    } catch (error) {
      console.log("Error in creating motivational plan!");
    } finally {
      setRecreateLoading(false);
    }
  };

  const handleClose = (key) => {
    if (key === "cancel") {
      setOpen(false);
    } else {
      setOpen(false);
      handleRecreatePlan();
    }
  };

  return (
    <>
      {firstLoad ? (
        <ActualDietPlanLoader motivationCoach={true} />
      ) : data?.data?.length === 0 && isPlanLoading ? (
        <ReacreationLoading
          timeLeft={timeLeft}
          minuteSet={120}
          data={motivationSlides}
          type="motivation"
          loaderHeading={t("motivationLoader.motivationProgress")}
          loaderSubheading={t("motivationLoader.analyzingPlan")}
          onComplete={() => fetchData()}
          onFailed={() => {
            setIsPlanLoading(false);
          }}
          stopCountdown={() => stopCountdown()}
          setTimeLeft={setTimeLeft}
        />
      ) : (
        <div className="MotivationCoach">
          <MainHeader
            heading="Stay Inspired Every Step of the Way"
            subheading="AI-powered motivation to keep you consistent, confident, and focused on your wellness journey."
            description="The Motivation Coach keeps your energy and determination high by analyzing your weekly activity across all modules — Diet, Exercise, Sleep, and Mindfulness — and turning it into personalized encouragement. Receive daily motivation, weekly recaps, and instant feedback when you hit milestones or fall behind. With dynamic badges, smart reminders, and inspiring messages from your AI coach, staying on track has never felt this rewardin"
            Image={HeaderImage}
          />
          {/* <div className="flex justify-end">
       <button onClick={()=>setOpen(true)} className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full px-4 py-3 mt-3 text-white">
        Open Modal
      </button>
     </div> */}
          {isPlanLoading && (
            <div className="mt-6">
              <ReacreationLoading
                timeLeft={timeLeft}
                minuteSet={120}
                data={motivationSlides}
                type="motivation"
                loaderHeading={t("motivationLoader.motivationProgress")}
                loaderSubheading={t("motivationLoader.analyzingPlan")}
                onComplete={() => fetchData()}
                onFailed={() => {
                  setIsPlanLoading(false);
                }}
                stopCountdown={() => stopCountdown()}
                setTimeLeft={setTimeLeft}
                recreateLoading={true}
              />
            </div>
          )}

          {data?.data?.length > 0 && (
            <div className="flex justify-end mt-3">
              <button
                className="px-8 py-3 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full text-white font-semibold"
                onClick={() => setOpen(true)}
              >
                {recreateLoading ? <ButtonLoader /> : "Regenerate Plan"}
              </button>
            </div>
          )}
          <DashboardSuggestion
            data={data?.data}
            setOpen={setOpen}
            recreateLoading={recreateLoading}
          />
          {/* <div className="grid grid-cols-1 xl:grid-cols-7 gap-5 mt-12">
        <div className="md:col-span-4">
          <GoalFeedBack />
        </div>

        <div
          className="p-6 rounded-xl text-white bg-cover xl:h-full relative md:col-span-3"
          style={{ backgroundImage: `url(${BackImg})` }}
        >
          <div className="flex justify-between items-center mb-10">
            <h4 className="text-[16px] font-[Lato] text-white">
              Recent Milestone Achieved
            </h4>
            <button
              className="bg-white rounded-md text-[#0575e6] text-[12px] font-[Lato] py-2 px-3"
            >
              View All
            </button>
          </div>
          <div className="flex justify-center  w-full mb-10">
            <div
              className={`bg-white rounded-3xl w-[85%] p-5 relative pb-8 ${
                badgeLocked && "blur-md scale-110"
              }`}
            >
              {" "}
              <h3 className="text-[16px] font-[600] font-[Lato] text-[#000] mt-[30%] text-center">
                Seasonal Challenger
              </h3>
              <div className="flex justify-center">
                <button
                  disabled
                  className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] py-2 px-4 text-[12px] my-2"
                >
                  {badgeLocked ? "Locked" : "Unlocked"}
                </button>
              </div>
              <div className="border border-[#DDDDDD] p-2 rounded-xl">
                <p className="text-[12px] text-[#5C5C5C] text-center">
                  Achieved by finishing a seasonal or holiday-themed quiz.
                </p>
              </div>
              <img
                src={gameMilestone}
                alt="image"
                className="absolute -top-[8%] left-1/2 -translate-x-1/2 z-[9] md:max-w-[30%] xl:max-w-[unset] w-[40%]  object-cover" // Adjusted positioning and added width
                style={{ maxHeight: "none" }} 
              />
            </div>
          </div>

          {badgeLocked && (
            <img
              src={LockSleepCoach}
              alt="image"
              className="absolute top-[44%] left-1/2 -translate-x-1/2 z-[9] object-cover"
            />
          )}
        </div>
      </div>
      <MilestonesPopup
        open={open}
        setOpen={setOpen}
        achievments={achievements[0]}
      /> */}
          <AlertDialog
            open={open}
            // handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            isLoading={recreateLoading}
            heading="Confirm Regeneration"
            message="Are you sure you want to regenerate your motivational coaching plan? This will refresh your guidance based on your latest inputs."
          />
        </div>
      )}
    </>
  );
};

export default MotivationCoach;
